export default __webpack_public_path__ + "static/media/trophy-solid-hover.13cb6054.svg";